import { defineComponent as _defineComponent } from 'vue'
import { AbTitle, AbLink, AbDescription } from '../../ui';
import AbList from '../AbList/AbList.vue';
import AbListItem from '../AbList/AbListItem.vue';
import AbButton from '../AbButton/AbButton.vue';
import { CdnImg } from '@webplatform/cdn-image';
import { TextAlign } from '../../../types';

interface Props {
  image?: {
    src?: string | null;
    alt?: string | null;
  } | null;
  title: string;
  description?: string | null;
  list?: string[] | null;
  links?:
    | {
        src?: string | null;
        text: string;
      }[]
    | null;
  caption?: string | null;
  contentAlign?: TextAlign | null;
  button?: {
    src: string;
    text?: string | null;
    color?: string | null;
    align?: TextAlign | null;
  } | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AbCardListItem',
  props: {
    image: null,
    title: null,
    description: null,
    list: null,
    links: null,
    caption: null,
    contentAlign: null,
    button: null
  },
  setup(__props: any) {

const IMAGE_RATIO_MAP = {
  square: {
    width: '664',
    height: '664',
  },
  rectangle: {
    width: '664',
    height: '332',
  },
};



const getImageSize = (
  image: {
    src?: string | null;
    alt?: string | null;
    ratio?: 'square' | 'rectangle';
  },
  side: 'width' | 'height',
) => {
  return image.ratio
    ? IMAGE_RATIO_MAP[image.ratio][side]
    : IMAGE_RATIO_MAP.square[side];
};

return { __sfc: true,IMAGE_RATIO_MAP, getImageSize, AbTitle, AbLink, AbDescription, AbList, AbListItem, AbButton, CdnImg }
}

})